import styles from "./Galerie.module.css";

import wedding3 from "../../assets/images/Galerie/wedding3.avif";
import wedding5 from "../../assets/images/Galerie/wedding5.avif";
import wedding6 from "../../assets/images/Galerie/wedding6.avif";

const images = [wedding6, wedding3, wedding5];

function Galerie() {
  return (
    <div className={styles.galleryWrapper}>
      <div className={styles.galleryContainer}>
        {images.map((image, index) => (
          <div className={styles.galleryItem} key={index}>
            <img
              src={image}
              alt={`Bild ${index + 1}`}
              className={styles.galleryImage}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Galerie;
